import { render, staticRenderFns } from "./image-display.vue?vue&type=template&id=04b76f1c&scoped=true&"
import script from "./image-display.vue?vue&type=script&lang=ts&"
export * from "./image-display.vue?vue&type=script&lang=ts&"
import style0 from "./image-display.vue?vue&type=style&index=0&id=04b76f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b76f1c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b76f1c')) {
      api.createRecord('04b76f1c', component.options)
    } else {
      api.reload('04b76f1c', component.options)
    }
    module.hot.accept("./image-display.vue?vue&type=template&id=04b76f1c&scoped=true&", function () {
      api.rerender('04b76f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/image-display.vue"
export default component.exports